const NotificationsType = {
    profile_updated: 1,
    profile_image_updated: 2,
    installer_user_updated: 3,
    installation_created: 4,
    installation_details_updated: 5,
    installation_status_changed: 6,
    device_reconnected: 7,
    device_disconnected: 8,
} as const;

const ReadStatus = {
    true: 1,
    false: 0,
} as const;

const Status = {
    deleted: 0,
    active: 1,
} as const;

const NotificationMessages = {
    profile_updated: 'Profile updated successfully',
    profile_image_updated: 'Profile image updated successfully',
    installer_user_updated: 'License number updated',
    installation_created_installer: 'New installation request has been assigned to you',
    installation_created_customer: 'Installation request has been created',
    installation_details_updated: 'Installation request has been updated',
    installation_status_changed: 'Installation status change to',
    device_reconnected: 'Your device is back online',
    device_disconnected: 'Your device went offline',
} as const;

const PushNotificationsTitle = {
    title: 'WATTER',
} as const;

const Platforms = {
    ios: 1,
    android: 2,
    web: 3,
} as const;

type NotificationsValuesType = (typeof NotificationsType)[keyof typeof NotificationsType];
type ReadStatusType = (typeof ReadStatus)[keyof typeof ReadStatus];
type StatusType = (typeof Status)[keyof typeof Status];
type NotificationMessagesType = (typeof NotificationMessages)[keyof typeof NotificationMessages];
type PushNotificationsTitleType = (typeof PushNotificationsTitle)[keyof typeof PushNotificationsTitle];
type PlatformsType = (typeof Platforms)[keyof typeof Platforms];

export {
    NotificationsType,
    ReadStatus,
    Status,
    NotificationMessages,
    PushNotificationsTitle,
    Platforms,
    PlatformsType,
    PushNotificationsTitleType,
    NotificationMessagesType,
    StatusType,
    ReadStatusType,
    NotificationsValuesType,
};
